<section class="section">
    <div class="container-fluid">
        <div class="row d-flex justify-content-end">
            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'name')" [(ngModel)]="productName">
                        <option selected disabled value="">Select Product Name</option>
                        <option value="all">All</option>
                        <option *ngFor="let name of this.productNameDetails">{{name}}</option>
                    </select>
                    <label for="floatingSelect">Product Name</label>
                </div>
            </div>

            <!-- CATEGORY -->
            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" [(ngModel)]="categoryId" (change)="updateDetails($event,'category')">
                        <option value="">Select Category</option>
                        <option value="all">All</option>
                        <option *ngFor="let cat of categoryList" [value]="cat.categoryId">
                            {{ cat.categoryName }}
                        </option>
                    </select>
                    <label>Category</label>
                </div>
            </div>

            <!-- SUB CATEGORY -->
            <!-- <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" [(ngModel)]="subCategoryId"
                        (change)="updateDetails($event,'subcategory')">
                        <option value="">Select Sub Category</option>
                        <option value="all">All</option>
                        <option *ngFor="let sub of subCategoryList" [value]="sub.subCategoryId">
                            {{ sub.subCategoryName }}
                        </option>
                    </select>
                    <label>Sub Category</label>
                </div>
            </div> -->

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'date')" [(ngModel)]="productCreationDate">
                        <option selected disabled value="">Select Product Created Date</option>
                        <option value="all">All</option>
                        <option *ngFor="let date of this.productCreationDateDetails">{{date}}</option>
                    </select>
                    <label for="floatingSelect">Created Date</label>
                </div>
            </div>

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'status')" [(ngModel)]="productStatus">
                        <option selected disabled value="">Select Availability Status</option>
                        <option value="all">All</option>
                        <option *ngFor="let status of this.productCurrentStatus">{{status}}</option>
                    </select>
                    <label for="floatingSelect">Availability Status</label>
                </div>
            </div>

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
                    <label class="text-gray">Search</label>
                </div>
            </div>
        </div>

        <div class="row justify-content-end mt-3 gap-2">

            <!-- EXCEL -->
            <div class="col-auto mb-2">
                <button class="btn btn-success" (click)="downloadProductExcel()">
                    <i class="bi bi-file-earmark-excel me-1"></i> Excel
                </button>
            </div>

            <!-- PDF -->
            <div class="col-auto mb-2">
                <button class="btn btn-danger" (click)="downloadProductPdf()">
                    <i class="fas fa-file-pdf me-1"></i> PDF
                </button>
            </div>

            <!-- CLEAR FILTER -->
            <div class="col-auto mb-2">
                <button class="btn btn-secondary" (click)="resetReviewFilter()">
                    Clear Filters
                    <img class="img-fluid ms-1" alt="clear" src="assets/img/icons/clear-alt.png">
                </button>
            </div>

        </div>

        <div class="py-2"></div>


        <div class="container-fluid">
            <div class="table-style table-responsive table-bordered">
                <table class="table table-head-fixed text-nowrap text-center">
                    <thead>
                        <tr class="sticky-top">
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Created Date / Time</th>
                            <th>Availability Status</th>
                            <th>Category</th>
                            <th>Sub Category</th>
                            <th>View Variants</th>
                            <th>Edit</th>
                            <!-- <th>Delete Images</th> -->
                            <th>Delete Product</th>
                        </tr>
                    </thead>
                    <tbody class="text-center"
                        *ngIf="(productDetails | filter:searchText).length > 0; else noDataFound">
                        <tr *ngFor="let item of this.productDetails | filter: searchText; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item?.productName || "-"}}</td>
                            <td>{{item?.createdAt | date : "dd-MM-yyy / hh:mm:ss aa"}}</td>
                            <td>
                                <select class="form-select" [(ngModel)]="item.availability"
                                    (change)="selectCurrentStatusUpdate(item)">
                                    <option disabled value="">Select a Availability</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </td>
                            <td>{{item?.categoryDetails?.categoryName || "-"}}</td>
                            <td>{{item?.subCategoryDetails?.subCategoryName || "-"}}</td>
                            <td><span class="fa fa-eye" (click)="openVariantModal(item)"></span> </td>
                            <td><button class="btn btn-secondary border rounded-pill border-dark"
                                    (click)="EditAlert(item)"> Edit <i class="fas fa-pen"
                                        tooltip="Click to edit the product"></i> </button></td>
                            <!-- <td><button class="btn btn-danger btn-sm border rounded-pill border-danger"
                                    (click)="deleteProduct(item)">
                                    <i class="fas fa-trash"></i> Delete
                                </button></td> -->
                            <td><button class="btn btn-danger btn-sm border rounded-pill border-danger"
                                    (click)="deleteProduct(item)">
                                    <i class="fas fa-trash"></i> Delete
                                </button></td>
                        </tr>
                    </tbody>
                    <ng-template #noDataFound>
                        <tr class="text-center ubuntu-bold h6 text-danger">
                            <td colspan="13">Data Not Found</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>
</section>

<!-- Variant details model popup -->
<!-- Variant Modal -->
<div class="modal fade show d-block" *ngIf="isVariantModalOpen">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">
                    Variant Details - {{ selectedProduct?.productName }}
                </h5>
                <button class="btn-close" (click)="closeVariantModal()"></button>
            </div>

            <div class="modal-body p-0">
                <div class="table-responsive">
                    <table class="table table-bordered text-center align-middle mb-0">
                        <thead class="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Size</th>
                                <th>Barcode</th>
                                <th>Quantity</th>
                                <!-- <th>MRP</th> -->
                                <th>SRP</th>
                                <th>Status</th>
                                <th>Action</th>
                                <th>Remove Variant</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let v of variantTableData; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ v.size }}</td>
                                <td>{{ v.barcodeNumber }}</td>
                                <td>
                                    <input type="number" class="form-control form-control-sm"
                                        [(ngModel)]="v.varientQuantity" min="0" (keypress)="allowOnlyNumbers($event)">
                                </td>

                                <!-- <td>
                                    <input type="number" class="form-control form-control-sm"
                                        [(ngModel)]="v.productMrp">
                                </td> -->

                                <td>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="v.productSrp"
                                        min="0" (keypress)="allowOnlyNumbers($event)">
                                </td>

                                <td>
                                    <select class="form-select form-select-sm" [(ngModel)]="v.isAvailable"
                                        (ngModelChange)="v.isAvailable = $event === 'true'">

                                        <option value="">Select a status</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>

                                    </select>
                                </td>


                                <td>
                                    <button class="btn btn-success btn-sm" [disabled]="v.isUpdating"
                                        (click)="updateSingleVariant(v)">
                                        <span *ngIf="!v.isUpdating">Update</span>
                                        <span *ngIf="v.isUpdating" class="spinner-border spinner-border-sm"></span>
                                    </button>
                                </td>

                                <td>
                                    <button class="btn btn-danger btn-sm" [disabled]="v.isDeleting"
                                        (click)="removeVariant(v)">

                                        <span *ngIf="!v.isDeleting">
                                            Remove
                                        </span>

                                        <span *ngIf="v.isDeleting" class="spinner-border spinner-border-sm">
                                        </span>
                                    </button>
                                </td>
                            </tr>

                            <tr *ngIf="variantTableData.length === 0">
                                <td colspan="8" class="text-danger fw-bold">
                                    No Variant Found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-secondary" (click)="closeVariantModal()">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>